/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2V1L21lc3NhZ2Utc2VxdWVuY2UvY29ubmVjdGlvbi1yZXF1ZXN0L2Nvbm5lY3Rpb24tcmVxdWVzdC5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
